import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applyCustomOrder()

    // Écouter les changements de positions depuis les préférences
    window.addEventListener('channelPositionsChanged', () => {
      this.applyCustomOrder()
    })
  }

  applyCustomOrder() {
    const positions = this.getChannelPositions()
    if (Object.keys(positions).length === 0) return

    const container = this.element
    const programs = Array.from(container.children)

    // Trier selon les positions personnalisées
    programs.sort((a, b) => {
      const channelIdA = a.dataset.channelId
      const channelIdB = b.dataset.channelId

      const posA = positions[channelIdA] || 999
      const posB = positions[channelIdB] || 999

      return posA - posB
    })

    // Réorganiser le DOM
    programs.forEach(program => {
      container.appendChild(program)
    })
  }

  getChannelPositions() {
    try {
      const stored = localStorage.getItem('tv_channel_positions')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
            return {}
    }
  }
}